<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import createFieldValidator from '$shared/helpers/form-validator';
  import { emailValidator } from '$shared/helpers/form-validator/validators';

  interface Props {
    value?: string;
    label?: string;
    name?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    readonly?: boolean;
    tabIndex?: number;
    onblur?: (e: FocusEvent) => void;
    onfocus?: (e: FocusEvent) => void;
    onchange?: (e: Event) => void;
    oninput?: (detail: { value: string }) => void;
  }

  let {
    value = '',
    label = 'Email',
    name = 'email',
    required = false,
    disabled = false,
    placeholder = '',
    readonly = false,
    tabIndex = 1,
    onblur,
    onfocus,
    onchange,
    oninput
  }: Props = $props();

  const [emailValidity, emailFieldValidator] = createFieldValidator([emailValidator(required)]);

  const onInput = (detail: { value: string }): void => {
    oninput?.(detail);
  };
</script>

<div class="comp-email-input" use:emailFieldValidator={value}>
  <Input
    {label}
    {name}
    {value}
    {required}
    {disabled}
    {placeholder}
    {readonly}
    {tabIndex}
    error={$emailValidity.message || ''}
    oninput={onInput}
    {onblur}
    {onfocus}
    {onchange}
  />
</div>
